// or less ideally
import {Container, Row, Col} from "react-bootstrap";
import "./chatbot.css";
import logo from "./../assets/logo.png";
import {ChatBot} from "./Chatbot";
import Header from "../layout/header";
import Footer from "../layout/footer";

export const ChatBotContainer = () => {
  return (
    <>
      <Header />
      <div id="container">
        <Container>
          <Row className="justify-content-center">
            <Col md={3}>
              {" "}
              <img id="logo"
                src={logo}
                alt="Logo"
                className="w-100"/>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8}>
              <ChatBot/>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer/>
    </>

  );
};
